/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDatabase = createReactComponent("database", "IconDatabase", [
  ["path", { d: "M12 6m-8 0a8 3 0 1 0 16 0a8 3 0 1 0 -16 0", key: "svg-0" }],
  ["path", { d: "M4 6v6a8 3 0 0 0 16 0v-6", key: "svg-1" }],
  ["path", { d: "M4 12v6a8 3 0 0 0 16 0v-6", key: "svg-2" }]
]);

export { IconDatabase as default };
//# sourceMappingURL=IconDatabase.js.map
